import { ThemeProvider } from 'next-themes';
import Aoscompo from '../../utils/aos';
import AppDownloadBanner from '../../widgets/AppDownloadBanner';
import { Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import Loading from './Loading';
import Header from '../header';
import ScrollToTop from './scrollToTop';
import GlobalToast from './GlobalToast';


export default function RootLayout() {

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // ⚡ Replace this timer with your real data-fetching / auth-check logic
    const timer = setTimeout(() => setIsLoading(false), 2800);
    return () => clearTimeout(timer);
  }, []);

  return (

    <>

      <ThemeProvider
        attribute="class"
        enableSystem={true}
        defaultTheme="system"
      >
        <AnimatePresence mode="wait">
          {isLoading ? <Loading key="loading" /> : <>

            <Aoscompo>
              <AppDownloadBanner />



              <Header />

              <GlobalToast />

              {/* {children} */}
              <Outlet />


              {/* <Footer /> */}
            </Aoscompo>
            <ScrollToTop />

          </>

          }
        </AnimatePresence>

      </ThemeProvider>
    </>
  );
}
